import { render, staticRenderFns } from "./SearchResultEvents.vue?vue&type=template&id=4da82530&"
import script from "./SearchResultEvents.vue?vue&type=script&lang=js&"
export * from "./SearchResultEvents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports